import React from 'react';


export class Rules extends React.Component{
    render(){
        return(
            <div>
                <h2>Pohjola Sairaalan elämänpyörä <br />-arvonnan säännöt</h2>
                <p>
Osallistumalla Pohjola Sairaalan elämänpyörä -kampanjaan (”Kampanja”) osallistuja hyväksyy nämä Kampanjan säännöt ja sitoutuu noudattamaan niitä sekä Kampanjan järjestäjän näiden sääntöjen nojalla tekemiä päätöksiä. 
</p>
<p>
1.	Kampanjan Järjestäjä 
</p>
<p>
Kampanjan järjestää:
</p>
<p>
Pohjola Terveys Oy (”Järjestäjä”)<br />
Y-tunnus: 2452505-5<br />
Postiosoite: PL 930, 00101 Helsinki.<br />
Käyntiosoite: Puutarhurinkuja 2, 00300 Helsinki
</p>
<p>
2.	Kampanjan alkamis- ja päättymispäivä  
</p>
<p>
Kampanja alkaa 14.5.2019 ja päättyy 14.5.2019.
 </p>
<p>

3.	Kuka voi osallistua?
</p>
<p>
Kampanjaan voivat osallistua kaikki Suomessa pysyvästi asuvat, yli 15-vuotiaat yksityishenkilöt, pois lukien Järjestäjän ja sen kanssa samaan konserniin kuuluvien yhtiöiden työntekijät ja heidän perheenjäsenensä sekä muiden tämän Kampanjan suunnitteluun, valmisteluun tai toteutukseen osallistuvien yritysten työntekijät ja heidän perheenjäsenet. Jokainen yksityishenkilö voi osallistua Kampanjaan vain yhden kerran.  
</p>
<p>

4.	Osallistumisohjeet  
</p>
<p>
Arvontaan osallistuu pyöräyttämällä elämänpyörää ja jättämällä yhteystiedot arvontaa varten. Arvontaan osallistuminen ei edellytä ostamista, eikä yhteydenottopyynnön jättämistä tai markkinointiluvan antamista. Arvontaan osallistujat sitoutuvat noudattamaan lakia, hyvää tapaa, sekä näitä kilpailusääntöjä.
</p>
<p>

5.	Palkinnot 
</p>
<p>
Palkintona on Finnkinon neljän lipun elokuvalippupaketti. Palkinnon arvo on 47 euroa. Palkintoa ei voi muuttaa rahaksi, muuhun tavaraan tai tapahtumaan.
</p>
<p>
Järjestäjä vastaa palkinnon mahdollisista toimituskustannuksista. Järjestäjä ei vastaa muista kustannuksista, joita voi liittyä palkinnon hyödyntämiseen. 
</p>
<p>
Järjestäjä vastaa kuitenkin palkintoon liittyvästä mahdollisesta arpajaisverosta.
</p>
<p>

6.	Voittajien valitseminen
</p>
<p>
Voittajien arvonta suoritetaan 14.5.2019 Kuopiossa. Voittajiin ollaan yhteydessä henkilökohtaisesti. Mikäli voittajaa ei tavoiteta kahden viikon kuluessa arvonnan suorittamisesta, on Järjestäjällä oikeus suorittaa arvonta tältä osin uudelleen. 
</p>
<p>

7.	Järjestäjän vastuu 
</p>
<p>
Osallistujat vapauttavat Järjestäjän sekä Kampanjan mahdolliset yhteistyökumppanit vahingosta, joka aiheutuu tai jonka väitetään aiheutuneen osallistumisesta tähän Kampanjaan. Järjestäjä ei vastaa Kampanjan palkintojen tai niiden käyttämisestä mahdollisesti aiheutuneista vahingoista. Järjestäjän vastuu rajoittuu Kampanjan säännöissä mainittujen palkintojen kokonaisarvoon.
</p>
<p>
Järjestäjä ei vastaa tietoteknisistä syistä johtuvista ongelmista tai esteistä Kampanjaan osallistumisessa tai palkintojen vastaanottamisessa.
</p>
<p>
8.	Muutokset
</p>
<p>
Järjestäjä pidättää oikeuden tehdä muutoksia Kampanjaan, sen sääntöihin tai sen toteutukseen. Kaikista muutoksista ilmoitetaan näissä säännöissä tai erillisellä Kampanjasivustolla, jos sellainen on käytössä. 
</p>
<p>
9.	Henkilötietojen käyttö
</p>
<p>
Henkilötietojen käsittelystä tietoa löytyy tietosuojaselosteesta <a href="https://www.pohjolasairaala.fi/fi/tietoa-meista/tietosuojaseloste-sidosryhmille" target="_blank">https://www.pohjolasairaala.fi/fi/tietoa-meista/tietosuojaseloste-sidosryhmille</a>. Lisätietoa henkilötietojen käsittelystä Pohjola Sairaalassa löytyy täältä <a href="https://www.pohjolasairaala.fi/fi/tietoa-meista/tietosuojaseloste" target="_blank">https://www.pohjolasairaala.fi/fi/tietoa-meista/tietosuojaseloste</a>
</p>



            </div>
        );
    }
}


// WEBPACK FOOTER //
// ./src/app/components/Rules.js